import React from 'react';

export const Arrow = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M8.773 21.2002L17.3298 12.6357C17.491 12.4744 17.5831 12.2428 17.5831 12C17.5831 11.7572 17.491 11.5256 17.3298 11.3643L8.773 2.7998L7.76953 4.07031L15.6915 12L7.76953 19.9297L8.773 21.2002Z"
      fill="#596056"
    />
    <path
      d="M7.68773 19.921C7.68569 19.9607 7.69718 19.9997 7.72034 20.0294L8.71321 21.2999C8.76155 21.3618 8.84503 21.3675 8.89943 21.3126L17.3659 12.7482C17.5536 12.5583 17.6611 12.2856 17.6611 12.0001C17.6611 11.7146 17.5536 11.4419 17.3659 11.2521L8.89943 2.68762C8.84503 2.6327 8.76155 2.63846 8.71321 2.70031L7.72034 3.97082L7.6946 4.0216C7.68904 4.03995 7.68671 4.05946 7.68773 4.07922C7.68979 4.11893 7.70537 4.1563 7.7315 4.18273L15.4582 12.0001L7.7315 19.8175C7.70537 19.8439 7.68979 19.8813 7.68773 19.921ZM15.7448 12.1124C15.773 12.084 15.7895 12.043 15.7895 12.0001C15.7895 11.9573 15.773 11.9163 15.7448 11.8878L8.00525 4.05773L8.8222 3.01086L17.1908 11.4767C17.322 11.6094 17.3968 11.8001 17.3968 12.0001L17.3933 12.0743C17.3772 12.2468 17.3056 12.4074 17.1908 12.5236L8.8222 20.9884L8.00525 19.9415L15.7448 12.1124Z"
      fill="#596056"
    />
  </svg>
);
